import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { Grid } from '@material-ui/core';
import renderSelectField from './renderSelectField';
import { setPropsAsInitial } from '../../helpers/setPropsAsInitial';
import moment from 'moment';
import { filterArrayEqual } from "../../functions/arrays";


class SelectForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      date: {}
    }
  }
  getPeriod = () => {
    let date = new Date();
    //console.log(this.props.parameters)
    let meses = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
    let result = []
    /* result =    [
        // { id: '0', month: 'Todos los movimientos', value: JSON.stringify({month: 'Todos los movimientos' }) },
        { id: '1', month: meses[this.cierre(date, 0).month] + ' - ' + this.cierre(date, 0).year, value: JSON.stringify({ month:(this.cierre(date, 0).month ), year: this.cierre(date, 0).year }) },
        { id: '2', month: meses[this.cierre(date, 1).month] + ' - ' + this.cierre(date, 1).year, value: JSON.stringify({ month:(this.cierre(date, 1).month ), year: this.cierre(date, 1).year }) },
        { id: '3', month: meses[this.cierre(date, 2).month] + ' - ' + this.cierre(date, 2).year, value: JSON.stringify({ month:(this.cierre(date, 2).month ), year: this.cierre(date, 2).year }) },
        { id: '4', month: meses[this.cierre(date, 3).month] + ' - ' + this.cierre(date, 3).year, value: JSON.stringify({ month:(this.cierre(date, 3).month ), year: this.cierre(date, 3).year }) },
        { id: '5', month: meses[this.cierre(date, 4).month] + ' - ' + this.cierre(date, 4).year, value: JSON.stringify({ month:(this.cierre(date, 4).month ), year: this.cierre(date, 4).year }) },
    ] */

    let periodConsult = (filterArrayEqual(this.props.classes.parameters, 'code', 'PERIOD_MAXIMUMS_OF_MOVEMENT_OF_CONSULT').length > 0) ? filterArrayEqual(this.props.classes.parameters, 'code', 'PERIOD_MAXIMUMS_OF_MOVEMENT_OF_CONSULT')[0].value : 3

    for (let i = 0; i < periodConsult; i++) {

      result = [...result,

      { id: (i + 1).toString(), month: meses[this.cierre(date, i).month] + ' - ' + this.cierre(date, i).year, value: JSON.stringify({ month: (this.cierre(date, i).month), year: this.cierre(date, i).year }) },

      ]

    }
    return result
  }
  cierre = (fecha, menos) => {
    let date = moment().subtract(menos, 'M');
    /* Javascript recalcularÃ¡ la fecha si el mes es menor de 0 (enero)
      o mayor de 11 (diciembre) */
    //date.setMonth(fecha.getMonth() - menos);
    /* Obtenemos la fecha en formato YYYY-mm */
    //console.log(date.format("M"))
    return { month: parseInt(date.format("M")) - 1, year: date.format("YYYY") }
  }
  /* handleChange = (e) => {
      // let date = new Date();
      // let meses = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
      //this.setState({ date: { id: e.target.value, month: meses[this.cierre(date, e.target.value).month] + ' - ' + this.cierre(date, e.target.value).year } })
  } */
  render() {
    const { classes, handleSubmit, name, label, onSelected, dateValue } = this.props;
    // const { date } = this.state
    return (
      <form className={classes.form} onSubmit={handleSubmit}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={12} lg={12} xl={12}>
            <Field
              name={name}
              id={name}
              component={renderSelectField}
              onChange={e => { onSelected(e.target.value) }}
              defaultValue={dateValue}
              label={label}>
              <option value={"Todos los movimientos"}>Todos los movimientos</option>
              {
                this.getPeriod().map((v, k) => {
                  return <option key={v.id} value={v.value}>{v.month}</option>
                })
              }
            </Field>
          </Grid>
        </Grid>
      </form>
    );
  }
}

SelectForm.propTypes = {
  onSelected: PropTypes.func.isRequired,
};

const SelectReduxForm = reduxForm(
  {
    form: 'SelectForm',
    // validate
  }
)(SelectForm)

export default setPropsAsInitial(SelectReduxForm)
// export default SelectForm;
